
import axios from 'axios';
import React, { Component }  from 'react';


export class PreloadTariff extends Component {

  constructor(props) {
    super(props);


    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const { id, onUpdate } = this.props;
    if (id) {
      axios.get(`tariff/${id}`).then(res => {
        const tariff = res.data;
        let newTariff = {
          name: tariff.name,
          carrier: tariff.carrier.id,
          tariff_points: tariff.tariff_points
        };

        let newTariffPoints = [];
        tariff.tariff_points.forEach(tariffPoint => {
          newTariffPoints.push({
            cost: tariffPoint.cost,
            point: tariffPoint.point,
            service: tariffPoint.service
          })
        });

        newTariff.tariff_points = newTariffPoints;

        onUpdate(newTariff);
        this.setState({
          loading: false
        })
      })
    }
    else {
      this.setState({
        loading: false
      })
    }
  }

  render() {
    const { loading } = this.state;
    if (loading)
      return <React.Fragment />;

    return <React.Fragment>{this.props.children}</React.Fragment>
  }
}
